import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import InfoWindows from "./InfoWindows";
import { getDistance, getUrl, syncMap } from "../../utils/staticMethods";
import {
  AdvancedMarker,
  Pin,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { imageSet } from "../../pages/icons/AssetIcon/IconList";
import defaultImg from "../../assets/img/icon/Aircraft/Airliner_Black.png";
import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";
import circle from "../../assets/img/m1.png/clusterIcon.png";
import useSrlHelper from "../../hooks/useSrlHelper";
import { Badge } from "react-bootstrap";

const CommonMapItems = ({
  showNearByAssets,
  showNearByZones,
  nearbyItems,
  // reportId,
  // report,
  onCurrentChanged,
}) => {
  const map = useMap();
  const mapsLib = useMapsLibrary("maps");
  const coreLib = useMapsLibrary("core");
  const markerLib = useMapsLibrary("marker");

  const { itemDisplayName } = useSrlHelper();

  const nearbyItemsRef = useRef();

  const [nearbyTrackedItems, setNearbyTrackedItems] = useState([]);
  const [nearbyZones, setNearbyZones] = useState([]);

  // const [defaultItemId, setDefaultItemId] = useState();
  const [selectedItemId, setSelectedItemId] = useState();

  const [updateInfoWindows, setUpdateInfoWindows] = useState(false);

  // const [infoWindowIds, setInfoWindowIds] = useState([]);

  const trackedItemsMarkersRef = useRef(new Map());
  const zonesMarkersRef = useRef(new Map());
  const markerClustererRef = useRef();
  const [markerClustererReady, setMarkerClustererReady] = useState(false);

  useEffect(() => {
    if (!map || !markerLib) return;
    // Once we have the map and the markerLib loaded, create an empty clusterer
    markerClustererRef.current = new MarkerClusterer({
      map: map,
      // markers: markers.values(),
      // markers: markersRef.current.values().toArray(),
      algorithm: new SuperClusterAlgorithm({
        radius: 30,
        maxZoom: 15,
      }),
      renderer: {
        render({ position, count }) {
          var marker = new markerLib.AdvancedMarkerElement({
            map: map,
            position: position,
          });
          const myDiv = document.createElement("div");
          ReactDOM.render(
            <div
              style={{
                // backgroundColor: "blueviolet",
                // color: "white",
                textAlign: "center",
              }}
            >
              <img src={circle} width={"24px"} alt="Cluster" />
              <br />
              <Badge pill bg="info">
                {count}
              </Badge>
            </div>,
            myDiv
          );
          marker.appendChild(myDiv);
          marker.style.translate = "0 12px";

          return marker;
        },
      },
      onClusterClick(e, cluster) {
        map.setZoom(16);
        map.panTo(cluster.marker.position);
        markerClustererRef.current.render();
      },
    });

    // map.setCenter({ lat: 51.26841464875889, lng: -1.088944107925282 });
    // map.setZoom(12);

    setMarkerClustererReady(true);

    return () => {
      if (markerClustererRef.current) {
        markerClustererRef.current.clearMarkers();
        markerClustererRef.current.map = null;
        markerClustererRef.current = null;
      }
    };
  }, [map, markerLib]);

  useEffect(() => {
    nearbyItemsRef.current = nearbyItems;
    setNearbyTrackedItems(
      nearbyItems
        ? nearbyItems.filter((_) => {
            return showNearByAssets && _.type !== "zone";
          })
        : []
    );
    setNearbyZones(
      nearbyItems
        ? nearbyItems.filter((_) => {
            return showNearByZones && _.type === "zone";
          })
        : []
    );
  }, [nearbyItems]);

  useEffect(() => {
    if (!nearbyTrackedItems || !markerClustererReady) return;
    syncMap(trackedItemsMarkersRef.current, nearbyTrackedItems, {
      onAdd: (item) => createTrackedItemMarker(item), // returns marker instance
      onModify: (item, marker) => updateTrackedItemMarker(marker, item),
      onDelete: (marker) => removeTrackedItemMarker(marker),
    });

    markerClustererRef.current.render();
    setUpdateInfoWindows(true);
  }, [nearbyTrackedItems, markerClustererReady]);

  const createTrackedItemMarker = useCallback(
    (item) => {
      var marker = new markerLib.AdvancedMarkerElement({
        map: map,
        position: {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
        },
      });
      const myDiv = document.createElement("div");
      var displayName = itemDisplayName(item);
      const imageSrc = imageSet[getUrl(item.icon)]
        ? require("../../assets/img/icon/" + imageSet[getUrl(item.icon)])
            .default
        : defaultImg;
      ReactDOM.render(
        <div className="d-flex flex-column align-items-center">
          <img src={imageSrc} width={"24px"} alt="Tracked Item Marker" />
          <div className="mt-4 px-2 text-nowrap text-break text-white position-absolute bg-black bg-opacity-25">
            {displayName}
          </div>
        </div>,
        myDiv
      );
      marker.appendChild(myDiv);
      marker.trackedItem = item;
      marker.trackedItem.showInfo = false;
      marker.style.translate = "0 12px";

      marker.addListener(
        "click",
        (e) => {
          // debugger;
          // const selectedItemId =
          //   e.domEvent?.srcElement?.parentElement?.parentElement?.trackedItem
          //     ?.id ?? "";

          marker.trackedItem.showInfo = !marker.trackedItem.showInfo;
          const selectedItemId = marker.trackedItem.id;

          setSelectedItemId(selectedItemId);
          onCurrentChanged &&
            onCurrentChanged({
              current: {
                lastPosition: marker.trackedItem,
                type: marker.trackedItem.type,
              },
              marker: marker,
            });

          // var found =
          //   nearbyItemsRef.current &&
          //   nearbyItemsRef.current.find((_) => _.id === selectedItemId);

          // if (found) {
          //   onCurrentChanged({
          //     current: { lastPosition: found, type: found.type },
          //   });
          // setInfoWindowIds((prev) => {
          //   // toggle in array
          //   return prev.includes(selectedItemId)
          //     ? prev.filter((v) => v !== selectedItemId) // remove it
          //     : [...prev, selectedItemId]; // add it
          // });
        }

        // if (map.getZoom() < 18) {
        //   map.setZoom(18);
        // }

        // onCurrentChanged &&
        //   onCurrentChanged({
        //     selectedItemId:
        //       e.domEvent.srcElement.parentElement.parentElement.trackedItem.id,
        //     selectedMarker: e.do,
        //   });
      );

      markerClustererRef.current.addMarker(marker, true);

      return marker;
    },
    [markerLib]
  );

  const updateTrackedItemMarker = (marker, item) => {
    marker.trackedItem = Object.assign(marker.trackedItem, item);
    marker.position = {
      lat: parseFloat(item.latitude),
      lng: parseFloat(item.longitude),
    };
    //marker.trackedItem = item;
    // return marker;
  };

  const removeTrackedItemMarker = useCallback((marker) => {
    markerClustererRef.current.removeMarker(marker, true);
    marker.setMap(null);
  });

  useEffect(() => {
    syncMap(zonesMarkersRef.current, nearbyZones, {
      onAdd: (item) => createZoneMarker(item), // returns marker instance
      onModify: (item, marker) => updateZoneMarker(marker, item),
      onDelete: (marker) => removeZoneMarker(marker),
    });
  }, [nearbyZones]);

  const createZoneMarker = useCallback((item) => {
    var latitude, longitude;
    try {
      latitude = parseFloat(item.latitude);
      longitude = parseFloat(item.longitude);
    } catch (error) {
      return null;
    }
    if (isNaN(latitude) || isNaN(longitude)) {
      console.log("NaN", { lat: item.latitude, lng: item.longitude });
      return null;
    }
    var marker = new markerLib.AdvancedMarkerElement({
      map: map,
      position: {
        lat: latitude,
        lng: longitude,
      },
    });
    const myDiv = document.createElement("div");
    const imageSrc = imageSet[getUrl(item.icon)]
      ? require("../../assets/img/icon/" + imageSet[getUrl(item.icon)]).default
      : defaultImg;
    ReactDOM.render(<img src={imageSrc} width={"32px"} alt="Cluster" />, myDiv);
    marker.appendChild(myDiv);
    marker.trackedItem = item;
    marker.style.translate = "0% 50%";

    if (item.radius) {
      let c = new mapsLib.Circle({
        id: item.id,
        idsArr: [item.id],
        ids: [item],
        strokeColor: "#090B29",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#090B29",
        fillOpacity: 0.4,
        shape: "circle",
        type: "zone",
        center: {
          lat: Number(item.latitude),
          lng: Number(Number(item.longitude)),
        },
        map: map,
        radius: Number(item.radius),
      });

      marker.geofence = c;
    } else if (item.polygon) {
      // if this zone is a polygon area
      let firstItem = item.polygon[0].split(",");
      let minLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        maxLat = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        minLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) },
        maxLng = { lat: Number(firstItem[1]), lng: Number(firstItem[0]) };
      let arr = item.polygon.map((item) => {
        let me = item.split(",");
        let lng = Number(me[0]);
        let lat = Number(me[1]);
        if (lat > maxLat.lat) maxLat = { lat, lng };
        if (lat < minLat.lat) minLat = { lat, lng };
        if (lng > maxLng.lng) maxLng = { lat, lng };
        if (lng < minLng.lng) minLng = { lat, lng };
        return { lng, lat };
      });
      let point1 = new coreLib.LatLng(minLat);
      let point2 = new coreLib.LatLng(maxLat);
      let point3 = new coreLib.LatLng(minLng);
      let point4 = new coreLib.LatLng(maxLng);
      let d1 = getDistance(point1, point2);
      let d2 = getDistance(point3, point4);
      let d = d1 > d2 ? d1 : d2;
      marker.diam = Number(d);
      let polygon = new mapsLib.Polygon({
        paths: arr,
        idsArr: [item.id],
        ids: [item],
        id: item.id,
        type: "zone",
        shape: "polygon",
        strokeColor: "#000000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#242424",
        fillOpacity: 0.4,
        editable: false,
        map: map,
      });

      marker.geofence = polygon;
    }

    return marker;
  });

  const updateZoneMarker = useCallback((marker, item) => {
    if (marker) {
      marker.position = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      };
      marker.trackedItem = item;
    }
  });

  const removeZoneMarker = useCallback((marker) => {
    if (marker) {
      if (marker.geofence) {
        marker.geofence.setMap(null);
        marker.geofence = null;
      }
      marker.setMap(null);
    }
  });

  const handleSelectedChanged = useCallback(
    ({ selectedItemId }) => {},
    [setSelectedItemId, onCurrentChanged]
  );

  return (
    <React.Fragment>
      <InfoWindows
        markersRef={trackedItemsMarkersRef}
        updateInfoWindows={updateInfoWindows}
        setUpdateInfoWindows={setUpdateInfoWindows}
      />
    </React.Fragment>
  );
};

export default CommonMapItems;
